/**
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import store from '@/store'
import router from '@/router'
import getPageTitle from '@/utils/pageTitle'
import { loginInterception, routesWhiteList, recordRoute } from '@/config'
import storage from '@/utils/storage'
import api from '@/api'
import { Toast, Dialog } from 'vant'

/**
 * 获取当前跳转登录页的Route
 * @param currentPath 当前页面地址
 */
function toLoginRoute(to) {
  const currentPath = to.fullPath
  if (recordRoute && currentPath !== '/')
    return {
      path: '/login',
      query: { redirect: encodeURIComponent(currentPath) },
      replace: true,
    }
  else return { path: '/login', replace: true }
}

function showMsg(msg) {
  Dialog.alert({
    title: '温馨提示',
    confirmButtonText: '知道了',
    message: msg,
    beforeClose: (action) => {
      new Promise((resolve) => {
        Toast('请联系管理员')
        resolve(false)
      })
    },
  }).then(() => {})
}

// const saveLoginTenant = (tenantId) => {
//   return new Promise((resolve, reject) => {
//     const loginTenant = JSON.parse(storage.get('hasLoginTenant')) || []
//     if (!loginTenant.includes(tenantId)) {
//       loginTenant.push(tenantId)
//     }
//     storage.set('hasLoginTenant', JSON.stringify(loginTenant))
//     resolve(true)
//   })
// }

export function setup() {
  router.beforeEach(async (to, from, next) => {
    // 出现异常不能阻塞流程
    let tenant = await store.getters['user/getTenant']
    if (to.name == 'Login') {
      next()
      return
    }
    let hasToken = store.getters['user/token']
    // vuex 获取租户信息

    if (!tenant) {
      await store
        .dispatch('user/GetTenantByCode')
        .then((data) => {
          const { Data } = data
          if (!Data.TenantId) {
            showMsg('当前租户已过期或已被禁用，请检查！')
            if (to.name != 'Login') {
              store.dispatch('user/resetAll')
            }
          }
        })
        .catch((e) => {
          if (e.Code === 2000) {
            showMsg('当前租户不存，请检查！')
          }
          console.log(e)
        })
    }

    const fromUrlToken = to.query.token
    if (fromUrlToken) {
      //await saveLoginTenant(tenant.TenantId)
      store.dispatch('user/setToken', fromUrlToken)
      hasToken = fromUrlToken
      storage.set('userId', to.query.userId)
    }

    if (!loginInterception) hasToken = true
    if (hasToken) {
      // 用于不同租户切换时确保绑定关系 -- 20220629暂时注释
      // const hasLoginTenant = JSON.parse(storage.get('hasLoginTenant')) || []
      // if (!hasLoginTenant || !hasLoginTenant.includes(tenant.TenantId)) {
      //   next(toLoginRoute(to))
      //   return
      // }

      const userInfo = store.getters['user/getUserInfo']
      if (!userInfo.UserId) await store.dispatch('user/getUserInfo')
      // 禁止已登录用户返回登录页
      if (to.path === '/login') {
        next({ path: '/' })
      } else next()
    } else {
      if (routesWhiteList.includes(to.path)) {
        next()
      } else next(toLoginRoute(to))
    }
  })
  router.afterEach((to) => {
    document.title = getPageTitle(to.meta.title)
  })
}
